module.exports = __webpack_public_path__ + "img/ai-img2.7e6d525c.png";